<template>
  <div>
    <PBannerBase height="auto" :inative="false" :isDefault="false" warning>
      <template #title>Atenção</template>
      Esse Webservice é apenas armazenado com as informações da permissão de
      acesso e próxima pagina a ser consumida em Sigecloud.
    </PBannerBase>
  </div>
</template>

<script setup lang="ts">
import { PBannerBase } from "@f360-dev/f360-prisma";
</script>
